export default __webpack_public_path__ + "static/media/verfication_envelop.ac008e9c.svg";